/**
 * Coauthor picker and chip list for post-backed creates.
 */
import React from "react";
import CoauthorSelect, { CoauthorSuggestion } from "components/Coauthors/CoauthorSelect";
import EntityAvatar from "components/Entities/EntityAvatar";
//import type { EntityAvatarEntity } from "components/Entities/EntityAvatar/entityAvatar.types";

export interface CoauthorSectionProps {
  coauthors: CoauthorSuggestion[];
  onAdd: (s: CoauthorSuggestion) => void;
  onRemove: (c: CoauthorSuggestion) => void;
  placeholder?: string;
  inputType?: "add" | "search";
}

const CoauthorSection: React.FC<CoauthorSectionProps> = ({
  coauthors,
  onAdd,
  onRemove,
  placeholder = "Add collaborators",
  inputType = "add",
}) => (
  <div className="form-control">
    <div className="flex flex-col gap-2">
      <CoauthorSelect
        inputType={inputType}
        placeholder={placeholder}
        className="w-full"
        onSelect={onAdd}
        excludeIds={coauthors.map((c) => c.id)}
      />
      {coauthors.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {coauthors.map((c) => (
            <EntityAvatar
              key={`${c.type}-${c.id}`}
              entity={c as any}
              entityType={c.type}
              entityChip
              showLink={false}
              showCloseChip
              onEntityChipClose={() => onRemove(c)}
            />
          ))}
        </div>
      ) : null}
    </div>
  </div>
);

export default CoauthorSection;
